export default __webpack_public_path__ + "static/media/gournay7.b6ca63e4.jpg";